import React from 'react';
import useModalStore from '../../store/VitalStore';
import { useNavigate } from 'react-router-dom';
import { FaReply } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';

export default function BtnContent({ children, type, cancel, to, onclick, school, funtion, action }) {

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleFuntion = () => {
    funtion();
  };



  if (cancel) {
    return (
      <button
        type='button'
        onClick={() => navigate(`${to}`)}
        className="flex items-center justify-center gap-2 bg-gradient-to-r from-slate-400 to-gray-500 text-white px-4 py-1 rounded-md shadow-md hover:from-slate-400 hover:to-gray-600 transition-all duration-300 ease-in-out"
      // className={`bg-gray-400 hover:bg-gray-600 cursor-pointer 
      // text-white  transition-all active:scale-95 p-3 md:py-1 rounded-md font-normal shadow-lg shadow-base-content/30 flex items-center gap-1 justify-center`}
      >
        {children}
      </button>
    );
  }

  if (type === 'cancel_modal') {
    return (
      <button
        type='button'
        onClick={() => handleFuntion()}
        className={`bg-gray-400 hover:bg-gray-600 cursor-pointer 
        text-white  transition-all active:scale-95 p-3 md:py-1 rounded-md font-normal shadow-sm shadow-base-content/80 flex items-center justify-center`}
      >
        {children}
      </button>
    );
  }

  if (type === 'button') {
    return (
      <button
        type='button'
        onClick={() => navigate(`${to}`)}
        className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out"
      >
        {children}
      </button>
    );
  }

  if (type === 'funtion') {
    return (
      <button
        type='button'
        onClick={() => handleFuntion()}
        className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out"
      >
        {children}
      </button>
    );
  }

  return (
    <button
      type={type && type}
      className="flex items-center justify-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out"
    // className={`
    //   text-white  transition-all p-3 md:py-1 rounded-md font-normal shadow-sm shadow-base-content/30 flex items-center justify-center ${type === 'submit'
    //     ? 'bg-p-sky hover:bg-p-sky/70 active:scale-95'
    //     : 'bg-gray-300'
    //   }`}
    >
      {children}
    </button>
  );
}
